// 文章 content(ProseMirror JSON)纯函数工具 — 与编辑器组件分离(避免 react-refresh
// fast-refresh 警告 + 供详情渲染层 article-render 复用)。

import type { JSONContent } from '@tiptap/core'
import type { FileRefAttrs } from './nodes/file-ref'
import type { PackRefAttrs } from './nodes/pack-ref'

/** 判定 content 是否为空 doc(无任何有效正文节点;嵌入节点视为有内容)。 */
export function isEmptyDoc(json: JSONContent | null | undefined): boolean {
  if (!json || !json.content || json.content.length === 0) return true
  const hasText = (node: JSONContent): boolean => {
    if (node.type === 'text' && (node.text ?? '').trim().length > 0) return true
    if (node.type === 'fileRef' || node.type === 'packRef' || node.type === 'image') return true
    return (node.content ?? []).some(hasText)
  }
  return !json.content.some(hasText)
}

/** 遍历 content 收集全部 fileRef.fileId / packRef.packId(供详情渲染层批量解析)。 */
export function collectEmbedIds(json: JSONContent | null | undefined): {
  fileIds: string[]
  packIds: string[]
} {
  const fileIds: string[] = []
  const packIds: string[] = []
  const walk = (node: JSONContent) => {
    if (node.type === 'fileRef') {
      const id = (node.attrs as FileRefAttrs | undefined)?.fileId
      if (id) fileIds.push(id)
    } else if (node.type === 'packRef') {
      const id = (node.attrs as PackRefAttrs | undefined)?.packId
      if (id) packIds.push(id)
    }
    ;(node.content ?? []).forEach(walk)
  }
  if (json) walk(json)
  return { fileIds: [...new Set(fileIds)], packIds: [...new Set(packIds)] }
}
